// @ts-nocheck
//#region imports
// import react & redux
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from 'redux'

//#region modules
import { actions as advisersActions } from '../../modules/advisersModule'
import { actions as appActions } from '../../modules/appModule'
import { actions as commonActions } from '../../modules/commonModule'
import { actions as favActions } from '../../modules/favouritesModule'
import { actions as lseActions } from "../../modules/lseModule"
import { actions as nexusActions } from "../../modules/nexusModule"
import { actions as newsActions } from "../../modules/newsModule"
import { actions as searchActions } from '../../modules/searchModule'
import { actions as synopsishActions } from '../../modules/synopsisModule'
//#endregion modules

import { exportToCsv } from "../../modules/exportToCsv"
import { firstCharacterToUpperCase, isChrome, isIos, isMSEdge, isNullOrWhiteSpace, notEmpty, toTitleCase } from "../../modules/utilities"
import { ACTIVITY_STATUS, BASE, CATEGORY, COLOR, CONSTANTS, COOKIES, JARGON, KEY_VALUES, KIND, LAYOUT, RADIO, SCOPE, TAB } from "../../modules/constants"
import { selectors as userSelectors } from "../../modules/userModule"
import COLUMNS from "../../modules/columns"

// import components
import DeleteFavouriteModal from "../../components/DeleteFavouriteModal"
import IdleLogoutModal from "../../components/IdleLogoutModal"
import ExportCsvModal from "../../components/ExportCsvModal"
import HomePageTabs from "../../components/HomePageTabs"
import Navbar from "../../components/layout/DashboardNavbar"
import MainSection from "../../components/layout/MainSection"
import Footer from "../../components/Footer"
import DataCard from "../../components/layout/DataCard"
import TitleBar from "../../components/layout/TitleBar"
import SearchMenu from "../../components/layout/SearchMenu"
import NexusMenu from "../../components/layout/NexusMenu"
import SearchResults from "../../components/layout/SearchResults"
import initStats from "../../components/layout/InitStats"
import MaxFavouritesReachedModal from "../../components/MaxFavouritesReachedModal"
import WhyRegisterModal from "../../components/WhyRegisterModal"
import StandardTrialModal from "../../components/StandardTrialModal"
import UrlTrialModal from "../../components/UrlTrialModal"
import UnderDevelopmentModal from "../../components/UnderDevelopmentModal"
import The350ClubIntroModal from "../../components/The350ClubIntroModal"
import GettingData from "../../components/searchCompanies/GettingData"
import { sortRows } from "../../components/NumerableTable"
import { createSearchRowData } from "../../components/layout/CreateSearchRowData"
import createHeadersData from "../../components/layout/CreateHeadersData"
import filterRows from "../../components/layout/FilterSearchResults"
import iconButtons from "../../components/layout/iconButtons"
import NumerableIconButton from "../../components/NumerableIconButton"
import ErrorModal from "../../components/ErrorModal"

// import mui
import Typography from "@mui/material/Typography"
import Divider from "@mui/material/Divider"

// import other
import { Dashboard } from "../dashboard"
import ChSearchForm from '../../forms/ChSearchForm'
import LseSearchForm from '../../forms/LseSearchForm'
import NsmSearchForm from '../../forms/NsmSearchForm'
import { analyseQuery, getTabIndex } from "./helpers/homeFunctions"
import { setAllCheckboxes, changeCheckbox } from "./helpers/checkboxFunctions"
import { analyseUrl, getKind, findKind, newUrl, validateTableInfoPage } from "./helpers/commonFunctions"
import { LoadFavouritesAndLSEs } from "./helpers/loadFavouritesAndLSEs"
import { handleToggleLseFavourite } from "./helpers/favouriteFuncs"
import getCheckboxMenu from "../../components/CheckboxMenus"

import history from "../../services/history"
import newsTimePeriodForm from "../../forms/NewsTimePeriodForm"

import checkboxSettingsForCsv from "../../components/layout/CheckboxSettingsForCsv"
//#endregion imports

class HomePage extends Component {

  //#region constructor
  constructor(props) {
    // console.clear()
    // console.log("%cHomePage constructor: props: ", "background: #b3ffb3", props)
    super()
    const { urlSource, searchStringObj } = analyseUrl(props)
    // console.log('searchStringObj:',searchStringObj)

    const tabIndex = getTabIndex(props.location.pathname, props.features)

    if (props.tabIndex !== tabIndex)
      props.common.setTabIndex(tabIndex)

    this.state = {
      searchString: decodeURIComponent(searchStringObj[TAB[BASE.SEARCH].INDEX]),
      nsmSearchString: "",
      searchStringObj,
      searchResults: {
        [SCOPE.COMPANIES]: { items: [], searchString: "", kind: KIND.SEARCH.COMPANIES },
        [SCOPE.OFFICERS]: { items: [], searchString: "", kind: KIND.SEARCH.OFFICERS },
      },
      favouriteToDelete: {},
      showCsvModal: false,
      showMaxFavouritesReached: false,
      showWhyRegisterModal: false,
      showStandardTrialModal: false,
      showUrlTrialModal: false,
      showUnderDevelopmentModal: false,
      showThe350ClubIntroModal: urlSource === JARGON.THE350CLUB,
    }
  }
  //#endregion constructor

  //#region React lifecycle methods
  componentDidMount() {
    // console.log("%ccomponentDidMount() this.props: ", "background: #ccf2ff", this.props)
    // Ensure favourites and LSEs are loaded and synced
    LoadFavouritesAndLSEs(this.props)
    // If we have come from nexus page to search page and a favourite has changed
    // we will need to call didMountSearch to sync favourites and search
    // NB: If we have simply refreshed the page, prevTabIndex will be undefined
    if (this.props.prevTabIndex)
      this.switchOnTabIndex(this.props.tabIndex)
    // console.log('this.props.tabIndex:',this.props.tabIndex);

    this.props.app.setPage(this.constructor.name)

    // console.log("features.Trial=" + this.props.features.Trial)
    // const cookies = document.cookie
    // const trialCookieSet = cookies.includes(COOKIES.URL_TRIAL_COOKIE)
    if (this.props.urlTrialDaysLeft != null && !this.props.urlTrialModalShown) {
      this.setState({ showUrlTrialModal: true })
    } else if (this.props.features.Trial && !this.props.standardTrialModalShown) {
      this.setState({ showStandardTrialModal: true })
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    // console.log("%cshouldComponentUpdate() nextProps: ", "background: #ffffcc", nextProps) // "color: blue; background: #ffffcc; font-weight: bold; text-decoration: underline; padding: 2px;"

    // While changed.length < 2, add any changed props to the array
    const changed = []
    Object.entries(this.props).every(([key, val]) => {
      if (nextProps[key] !== val)
        changed.push(key)

      return changed.length < 2
    })

    // If the only location and match have changed, analyse and save the setting and return false
    if (changed.every((val, index) => val === ["location", "match"][index])) {
      this.props.common.saveSettings({ ...this.props, ...analyseUrl(this.props) })
      return false
    } else
      return true
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log("%ccomponentDidUpdate() this.props: ", "background:  #ffccff", this.props)
    /*
        // Debug code for comparing current and next state
        Object.entries(this.props).forEach(([key, val]) =>
          prevProps[key] !== val && console.log(`Prop '${key}' changed`)
        )
        if (this.state) {
          Object.entries(this.state).forEach(([key, val]) =>
            prevState[key] !== val && console.log(`State '${key}' changed`)
          )
        }
    */

    const urlProps = analyseUrl(this.props)
    // console.log('urlProps:', urlProps)
    // console.log('this.props.checkboxes:',this.props.checkboxes)

    if (newUrl(this.props, urlProps))
      this.props.common.saveSettings({ ...this.props, ...urlProps })

    // Ensure favourites and LSEs are loaded and synced
    LoadFavouritesAndLSEs(this.props)

    const tabIndex = urlProps.tab.INDEX

    // If user logs out when on 'favourite' or 'lse' tab relocate to search tab
    if (this.props.features.Favourites !== true &&
      [TAB[BASE.FAVOURITES].INDEX].indexOf(tabIndex) > -1) {
      this.handleTabsChange(TAB[BASE.SEARCH].INDEX)
      this.handleLoggedOut()
    } else
      if (!this.props.features.LseAppts && TAB.isRestrictedLse(tabIndex)) {
        this.handleTabsChange(TAB[BASE.SEARCH].INDEX)
        // this.handleNotDeveloper()
        return
      }

    this.switchOnTabIndex(tabIndex)
  }

  switchOnTabIndex = tabIndex => {
    const { searchString, urlScope, seed } = analyseQuery(this.props)
    // console.log('tabIndex:',tabIndex);

    switch (tabIndex) {
      case TAB[BASE.SEARCH].INDEX:
        switch (urlScope) {
          case SCOPE.RANDOM:
            this.didMountRandom(seed)
            break

          case SCOPE.PEOPLE:
          case SCOPE.COMPANIES:
          default:
            this.didMountSearch(searchString, urlScope)
            break
        }
        break

      default:
        break
    }
  }

  didMountRandom = seed => {
    seed = seed || Math.floor(Math.random() * 1000000).toString()

    if (seed !== this.props.searchResults.seed)
      this.props.search.random({ ...this.props, seed })
  }

  didMountSearch = (searchString, urlScope) => {
    // console.log('didMountSearch this.props:', this.props)
    const { favourites, searchSynced } = this.props

    if (searchString)
      // If the search string doesn't match the results or the scope has changed,
      // submit the string to get new results
      if (searchString !== this.props.searchResults.searchString || urlScope !== this.props.scope) {

        this.props.search.submit({
          ...this.props,
          scope: urlScope,
          searchString,
          stateSearchResults: this.state.searchResults,
        })
      }
      else if (notEmpty(favourites) && !searchSynced) {
        this.props.search.syncWithFavourites({
          searchResults: this.props.searchResults,
          favourites,
        })
      } else
        if (this.state.searchResults[urlScope].searchString !== searchString) {
          let searchResults = this.state.searchResults
          searchResults[this.props.scope] = this.props.searchResults
          this.setState({ searchResults })
        }
  }
  //#endregion React lifecycle methods

  //#region logic & utility functions
  // this.setAllCheckboxes calls the imported setAllCheckboxes with added props
  setAllCheckboxes = props => {
    setAllCheckboxes({ ...this.props, ...props })
  }
  //#endregion logic & utility functions

  //#region event handlers
  onKeyPress = e => {
    if (e.key === 'Enter')
      e.preventDefault()
  }

  //#region  nsm search
  handleNsmSearchStringChange = ({ e }) =>
    this.setNsmSearchString(isNullOrWhiteSpace(e.target.value) ? "" : e.target.value)

  setNsmSearchString = nsmSearchString => {
    this.setState({
      nsmSearchString,
    })
  }
  //#endregion

  handleSearchStringChange = ({ e }) =>
    this.setSearchString(isNullOrWhiteSpace(e.target.value) ? "" : e.target.value)

  setSearchString = searchString => {
    const { searchStringObj, tabIndex } = this.props

    switch (tabIndex) {

      case TAB[BASE.SEARCH].INDEX:
        this.setState({
          searchString,
          scope: SCOPE.COMPANIES,
        })
        this.props.search.searchStringChanged(this.props.previousSearchString)
        break

      case TAB[BASE.LSE.COMPANIES].INDEX:
      case TAB[BASE.LSE.ROLES].INDEX:
      default:
        searchStringObj[tabIndex] = searchString
        this.props.common.historyPush({ ...this.props, searchStringObj })
        break
    }
  }

  handleSearchStringClear = tabIndex => {

    switch (tabIndex) {
      // Handle CH search - where we have a submit button
      case TAB[BASE.SEARCH].INDEX:
        this.setState({
          searchString: ''
        })
        this.props.search.searchStringChanged(this.props.previousSearchString)
        break

      // Handle LSE search - where we have no submit button
      default:
        // Clear the state.searchStringObj for the current tab.
        // (This is used in LseSearchForm when props.searchStringObj is ''
        // - as it will be when the page is mounted )
        this.setState({
          searchStringObj: { ...this.state.searchStringObj, [tabIndex]: '' }
        })
        this.setSearchString('')
        break
    }
  }

  handleSearchStringSubmit = props => {
    // console.log('handleSearchStringSubmit props:', props)
    const { e, hook, scope } = props
    e.preventDefault()
    const { checkboxes, searchStringObj, tabIndex } = this.props

    switch (tabIndex) {

      case TAB[BASE.SEARCH].INDEX:
        searchStringObj[tabIndex] = this.state.searchString
        this.props.common.historyPush({ ...this.props, scope, searchStringObj })
        this.props.search.submit({
          checkboxes,
          scope,
          searchString: this.state.searchString,
          stateSearchResults: this.state.searchResults,
          hook,
        })
        break

      default:
        break
    }
  }

  handleRandom = e => {
    e.preventDefault()
    document.getElementById('companySearchFormTextField').value = ''
    this.setState({
      searchString: '',
    })
    var seed = Math.floor(Math.random() * 1000000).toString()
    this.props.search.random({ ...this.props, seed })
  }

  handleLoggedOut = () => {
    this.setState({ showWhyRegisterModal: true })
  }

  handleNotDeveloper = () => {
    this.setState({ showUnderDevelopmentModal: true })
  }

  getItems = kind => {
    switch (kind) {
      case KIND.FAVOURITE.COMPANIES: return this.props.favourites.companies
      case KIND.FAVOURITE.PEOPLE: return this.props.favourites.people
      default: return this.props.searchResults.items
    }
  }

  handleSelect = row => {
    // console.log('handleSelect row:', row)

    // Set items as search results or favourites
    const items = this.getItems(row.kind)

    // Using the index of the selected table row,
    // save the search or favourite item on to the store as skeleton
    this.props.nexus.setSkeleton({ ...items[row.index], tabIndex: this.props.tabIndex })
    this.props.common.selectRow({ ...this.props, pathname: row.link })
    this.setState({
      searchString: this.props.previousSearchString,
    })
  }

  handleTabsChange = index => {
    // console.log('handleTabsChange: this.props', this.props)
    // Only called if user logs out and is on an invalid tab
    // (eg on lse when not trial or 350)
    this.props.common.changeTab(
      {
        ...this.props,
        index,
      })
  }

  handleDeleteFavourite = row => {
    // console.log('handleDeleteFavourite row:', row)
    this.setState({
      showDeleteFavouriteModal: true,
      favouriteToDelete: {
        category: row.category,
        _id: row._id,
        ids: row.ids,
        title: row.title,
      },
    })
  }

  handleOnSubmitDeleteFav = () => {
    const { advisers, advisersMeta, fav, lse, lseCompaniesMeta, lsePeopleMeta, news, newsMeta, search, searchResults, nexus, entities } = this.props
    const { category, _id, ids } = this.state.favouriteToDelete
    const isFavourite = false
    this.setState({ deleting: true })

    // Delete the favourite
    fav.delete(category, _id)

    // Sync searchResults
    search.updateIsFavouriteUsingIds({ searchResults, ids, isFavourite, })

    // Sync lseCompaniesMeta (TODO: auth stuff)
    if (category === CATEGORY.COMPANY) {
      lse.setIsFavouriteById({ lseCompaniesMeta, _id, isFavourite })
      news.setFavouriteByCompanyNumber({ newsMeta, companyNumber: _id, isFavourite })
      advisers.setIsFavouriteById(advisersMeta, _id, isFavourite)
    }
    else if (category === CATEGORY.PERSON) {
      lse.setIsFavouritePersonById({ lsePeopleMeta, _id, isFavourite })
    }

    // Sync entities
    nexus.setEntityIsFavourite(entities, _id, false)

    this.setState({ deleting: false, showDeleteFavouriteModal: false })
  }

  handleToggleLseFavourite = ({ kind, row }) => {
    switch (kind) {
      case KIND.SEARCH.COMPANIES:
      case KIND.SEARCH.OFFICERS:
        this.setState(handleToggleLseFavourite.search({ ...this.props, row }))
        break

      case KIND.LSE.COMPANIES.BOARD:
      case KIND.LSE.COMPANIES.OVERVIEW:
      case KIND.LSE.COMPANIES.GOVERNANCE:
      case KIND.LSE.COMPANIES.DATES:
      case KIND.LSE.COMPANIES.ADVISERS:
      case KIND.LSE.COMPANIES.COMMITTEES:
        this.setState(handleToggleLseFavourite.company({ ...this.props, row }))
        break

      case KIND.LSE.ADVISERS:
        this.setState(handleToggleLseFavourite.adviser({ ...this.props, row }))
        break

      case KIND.LSE.NEWS:
        this.setState(handleToggleLseFavourite.news({ ...this.props, row }))
        break

      case KIND.LSE.PEOPLE.BOARD:
      case KIND.LSE.PEOPLE.COMMITTEES:
        this.setState(handleToggleLseFavourite.person({ ...this.props, row }))
        break

      case KIND.FAVOURITE.COMPANIES:
      case KIND.FAVOURITE.PEOPLE:
        this.handleDeleteFavourite(row)
        break

      default:
        break
    }
  }

  handleOrderTable = props => {
    // console.log('props:', props)
    this.props.common.setTableOrder(props)
  }

  handleChangeCheckbox = ({ bit, hook }) =>
    changeCheckbox({ ...this.props, bit, hook })

  handleExportCsvClick = () => {
    this.setState({ showCsvModal: true })
  }

  handleExportCsvModalSubmit = props => {
    // console.log('handleExportCsvModalSubmit props:', props)
    this.setState({ showCsvModal: false })
    const columns = COLUMNS.LANDSCAPE // We always create csv using landscape
    const { checkboxes, tabIndex, tableOrder } = this.props
    const { includeSettingsChecked, items, kind } = props
    const stats = initStats()
    const showLogos = false
    var headers = createHeadersData({ ...this.props, columns, kind, showLogos })

    var rawRows = createSearchRowData({ ...this.props, columns, items, kind, showLogos, stats })
    const rawRowsLength = rawRows.length
    // We always create csv using landscape props so use orderSet 0
    rawRows = sortRows({ headers, rows: rawRows, tableOrder: tableOrder[kind][0] })

    // Limit the number of rows for users, but not developers
    const rows = rawRows.slice(0, this.props.features.Developer ? 10000 : KEY_VALUES.MAX_CSV_ROWS)

    const checkboxSettings = includeSettingsChecked ? checkboxSettingsForCsv({ checkboxes, kind, tabIndex }) : null

    // Derive filename (titleText) from 'KIND' - eg "LSE.COMPANIES.DATES" > "LSE Companies - Dates"
    const filename = toTitleCase(findKind(kind).replace('.', ' ').replace('.', ' - ')).replace("Lse", "LSE")
    const searchString = this.props.searchStringObj[tabIndex]

    exportToCsv({ filename, headers, rawRowsLength, rows, checkboxSettings, searchString })
  }
  //#endregion event handlers

  //#region get components
  showLseCompanies = kind => {
    const { checkboxes, lseCompaniesMeta, tabIndex } = this.props
    const { items } = lseCompaniesMeta
    const filter = this.props.searchStringObj[tabIndex]

    const searchResults = {
      filter,
      items: [],
      kind,
    }

    // Filter the items by search string and checkboxes
    if (items)
      searchResults.items = filterRows({ items, checkboxes, filter, searchResults, tabIndex })

    return searchResults
  }

  showLseAppointments = kind => {
    const { checkboxes, lseApptsMeta, tabIndex } = this.props
    const { items } = lseApptsMeta
    const filter = this.props.searchStringObj[tabIndex]

    const searchResults = {
      filter,
      items: [],
      kind,
    }

    // Filter the items by search string and checkboxes
    if (items)
      searchResults.items = filterRows({ items, checkboxes, filter, searchResults, tabIndex })
    // console.log('searchResults:', searchResults)

    return searchResults
  }

  showLsePeople = kind => {
    const { checkboxes, lsePeopleMeta, tabIndex } = this.props
    const { items } = lsePeopleMeta
    const filter = this.props.searchStringObj[tabIndex]

    const searchResults = {
      filter,
      items: [],
      kind,
    }

    // Filter the items by search string and checkboxes
    if (items)
      searchResults.items = filterRows({ items, checkboxes, filter, searchResults, tabIndex })
    return searchResults
  }

  showAdvisers = kind => {
    const { advisersMeta, checkboxes, tabIndex } = this.props
    const filter = this.props.searchStringObj[tabIndex]
    const searchResults = {
      filter,
      items: [],
      kind,
    }

    if (advisersMeta)
      searchResults.items = filterRows({ items: advisersMeta, checkboxes, filter, searchResults, tabIndex })

    return searchResults
  }

  showLseNews = kind => {
    const { checkboxes, newsIds, newsMeta, radio, tabIndex } = this.props
    const filter = this.props.searchStringObj[tabIndex]
    const searchResults = {
      filter,
      items: [],
      kind,
    }

    const filterByTimePeriod = radio => {
      const months = radio[BASE.LSE.NEWS] === RADIO[BASE.LSE.NEWS].MONTH ? 1 : 12
      var today = new Date()
      var newDate = new Date(today.setMonth(today.getMonth() - months)).getTime()
      return searchResults.items.filter(item => new Date(item.publicationDate).getTime() > newDate)
    }

    // Filter the items by search string and checkboxes
    if (newsMeta) {
      searchResults.items = filterRows({ items: newsMeta, checkboxes, filter, searchResults, tabIndex })

      searchResults.items = filterByTimePeriod(radio)

      // Filter by 'document contains'
      if (newsIds !== null)
        searchResults.items = searchResults.items.filter(item => newsIds.includes(item._id))
    }

    return searchResults
  }

  showSearchResults = () => {
    // console.log('showSearchResults this.props:', this.props)
    const { checkboxes, scope, searchResults, tabIndex } = this.props
    const { items, kind } = searchResults
    const filter = null

    const filteredSearchResults = {
      filter,
      items,
      kind,
      searchString: searchResults.searchString, // Required for ResultsMessage
    }

    searchResults.filter = filter

    // Filter the items by checkboxes - unless 'random'
    if (items && scope !== SCOPE.RANDOM)
      filteredSearchResults.items = filterRows({ items, checkboxes, filter, searchResults, tabIndex })

    filteredSearchResults.totalResults = items.length ?? 0

    return filteredSearchResults
  }

  favouritesEnabled = kind =>
    this.props.features.Favourites && (
      kind === KIND.SEARCH.COMPANIES ||
      kind === KIND.SEARCH.OFFICERS ||
      kind === KIND.FAVOURITE.COMPANIES ||
      kind === KIND.FAVOURITE.PEOPLE ||
      kind === KIND.LSE.COMPANIES.OVERVIEW ||
      kind === KIND.LSE.NEWS ||
      kind === KIND.LSE.ADVISERS ||
      kind === KIND.LSE.COMPANIES.GOVERNANCE ||
      kind === KIND.LSE.COMPANIES.COMMITTEES ||
      kind === KIND.LSE.COMPANIES.DATES ||
      kind === KIND.LSE.COMPANIES.BOARD ||
      kind === KIND.LSE.COMPANIES.ADVISERS ||
      kind === KIND.LSE.PEOPLE.BOARD ||
      kind === KIND.LSE.PEOPLE.COMMITTEES
    )

  // NB: These are the filtered searchResults
  SearchResultsComponent = searchResults => {
    const { orderSet } = this.props
    // console.log('searchResults:', searchResults)

    return (<SearchResults
      portrait={this.props.portrait}
      // Use rest operator to assign searchResults so that the page updates when
      // when sorting. searchResults simply references the instance so nothing has
      // changed ..so no redraw if we change sort table order
      searchResults={searchResults}
      handleOrderTable={props => this.handleOrderTable({ ...props, table: searchResults.kind, orderSet })}
      handleSelect={this.handleSelect}
      searchString={this.state.searchString}
      nsmSearchString={this.props.nsmSearchString}
      showLogos={CONSTANTS.ENABLE_LOGOS && this.props.features.ShowLogos}
      lseCompaniesEnabled={true}
      favouritesEnabled={this.favouritesEnabled(searchResults.kind)}
      handleClickFavouriteIcon={props => this.handleToggleLseFavourite(props)}
      tableOrder={this.props.tableOrder[searchResults.kind][orderSet]}
      // checkboxes={this.props.checkboxes} // Do we need this???
      checkboxes={this.props.checkboxes}
      tableAnalysis={this.props.features.TableAnalysis}
      tableInfo={this.props.tableInfo}
      lseCompaniesMeta={this.props.lseCompaniesMeta}
      the350club={this.props.the350club}
      tabIndex={this.props.tabIndex}
    />
    )
  }

  showFavouriteCompanies = kind => ({
    items: this.props.favourites?.companies ?? [],
    kind,
  })

  showFavouritePeople = kind => ({
    items: this.props.favourites?.people ?? [],
    kind,
  })

  searchForm = (filteredSearchResults, components) => {
    return (
      <ChSearchForm
        handleChangeCheckbox={this.handleChangeCheckbox}
        features={this.props.features}
        checkboxes={this.props.checkboxes}
        handleSearchStringChange={e => this.handleSearchStringChange(e)}
        handleSearchStringClear={this.handleSearchStringClear}
        handleSearchStringSubmit={(e, scope) => this.handleSearchStringSubmit(e, scope)}
        handleRandom={e => this.handleRandom(e)}
        searchString={this.state.searchString}
        searchResults={this.props.searchResults}
        newSearch={this.props.newSearch}
        filteredSearchResults={filteredSearchResults}
        tabIndex={this.props.tabIndex}
        rollups={this.props.rollups}
        handleRollupClick={e => this.props.app.toggleRollup(e)}
        components={components} // 1 for show textbox and buttons, 2 for checkboxes, and 3 for both
      />
    )
  }

  errorModal = () => {
    return (<div>
      <ErrorModal
        show={true}
        statusCode={this.props.statusCode}
        reasonPhrase={this.props.reasonPhrase}
        customReason={this.props.customReason}
        onHide={() => {
          this.props.search.setShowErrorModal({ isSuccessStatusCode: true })
          history.push(this.props.previousUrl)
        }
        }>
      </ErrorModal>
    </div>)
  }

  lseSearchForm = (tabIndex, label) =>
    <LseSearchForm
      handleSearchStringChange={e => this.handleSearchStringChange(e)}
      handleSearchStringClear={this.handleSearchStringClear}
      label={label}
      onKeyPress={e => this.onKeyPress(e)}
      // Because LseSearchForm uses the 'uncontrolled' defaultValue, we must initialise it
      // using the this.state.searchStringObj (set in constructor). Else it remains ''
      // even though this.props.searchStringObj changes. (Unless we change tabs!)
      searchString={this.props.searchStringObj[tabIndex] || this.state.searchStringObj[tabIndex]}
      tabIndex={tabIndex}
    />

  nsmSearchForm = ({ count, label, tabIndex }) =>
    <NsmSearchForm
      count={count}
      handleSearchStringChange={e => this.handleNsmSearchStringChange(e)}
      handleSearchStringSubmit={() => this.props.news.searchDocument({ searchString: this.state.nsmSearchString })}
      label={label}
      onKeyPress={e => this.onKeyPress(e)}
      nsmSearchString={this.state.nsmSearchString}
      tabIndex={tabIndex}
      news={this.props.news}
      searchString={this.props.nsmSearchString}
      errorMessage={this.props.newsErrorMessage}
    />

  csvButton = () => <NumerableIconButton item={{
    ...iconButtons.csv,
    disabled: !this.props.features.ExportCsv,
    tipDisabled: this.props.features.Trial
      ? iconButtons.csv.tipEnabled + JARGON.NOT_INCLUDED_IN_TRIAL
      : iconButtons.csv.tipDisabled,
    fontWeight: "normal",
    handleClick: () => this.setState({ showCsvModal: true }),
  }} />
  //#endregion get components

  render() {
    // console.log("render props: ", this.props)

    const { advisersMeta, features, lseApptsMeta, lseCompaniesMeta, lsePeopleMeta, newsMeta, portrait, radio, searchResults, standardTrialDaysLeft, tabIndex, tableInfo } = this.props
    // console.log('getKind(tabIndex, radio):', findKind(getKind(tabIndex, radio)))
    const kind = getKind(tabIndex, radio)
    // console.log('findKind(kind):', findKind(kind))

    const title = "Numerable"
    let searchIcon = false
    let titleText = ""
    let filteredSearchResults = { items: [] }

    const isLoggedIn = this.props.isLoggedIn

    const menuProps = {
      checkboxes: this.props.checkboxes,
      features,
      rollups: this.props.rollups,
      handleRollupClick: e => this.props.app.toggleRollup(e),
      portrait,
      favouritesEnabled: features.Favourites,
      handleChangeCheckbox: this.handleChangeCheckbox,
      handleLoggedOut: this.handleLoggedOut,
      isLoggedIn: isLoggedIn,
      tabIndex,
      kind,
      setAllCheckboxes: this.setAllCheckboxes,
    }

    switch (tabIndex) {
      case TAB[BASE.SEARCH].INDEX: // search
        titleText = `Search Companies House`
        filteredSearchResults = notEmpty(searchResults) ? this.showSearchResults() : { items: [] }
        searchIcon = true
        break

      case TAB[BASE.DASHBOARD].INDEX: // Dashboard
        titleText = `LSE Dashboard`
        break

      case TAB[BASE.LSE.COMPANIES].INDEX:
        titleText = `${JARGON.LSE} ${JARGON.COMPANIES}`

        switch (this.props.radio[BASE.LSE.COMPANIES]) {
          case RADIO[BASE.LSE.COMPANIES].GOVERNANCE:
            filteredSearchResults = notEmpty(lseCompaniesMeta) ? this.showLseCompanies(KIND.LSE.COMPANIES.GOVERNANCE) : { items: [] }
            break

          case RADIO[BASE.LSE.COMPANIES].COMMITTEES:
            filteredSearchResults = notEmpty(lseCompaniesMeta) ? this.showLseCompanies(KIND.LSE.COMPANIES.COMMITTEES) : { items: [] }
            break

          case RADIO[BASE.LSE.COMPANIES].ADVISERS:
            filteredSearchResults = notEmpty(lseCompaniesMeta) ? this.showLseCompanies(KIND.LSE.COMPANIES.ADVISERS) : { items: [] }
            break

          case RADIO[BASE.LSE.COMPANIES].DATES:
            filteredSearchResults = notEmpty(lseCompaniesMeta) ? this.showLseCompanies(KIND.LSE.COMPANIES.DATES) : { items: [] }
            break

          case RADIO[BASE.LSE.COMPANIES].BOARD:
            filteredSearchResults = notEmpty(lseCompaniesMeta) ? this.showLseCompanies(KIND.LSE.COMPANIES.BOARD) : { items: [] }
            break

          case RADIO[BASE.LSE.COMPANIES].OVERVIEW:
          default:
            filteredSearchResults = notEmpty(lseCompaniesMeta) ? this.showLseCompanies(KIND.LSE.COMPANIES.OVERVIEW) : { items: [] }
            break
        }
        break

      case TAB[BASE.LSE.ROLES].INDEX:
        titleText = `${JARGON.LSE} ${JARGON.APPTS}`

        switch (this.props.radio[BASE.LSE.ROLES]) {
          case RADIO[BASE.LSE.ROLES].BOARD:
            filteredSearchResults = notEmpty(lseApptsMeta) ? this.showLseAppointments(KIND.LSE.ROLES.BOARD) : { items: [] }
            break

          case RADIO[BASE.LSE.ROLES].COMMITTEES:
          default:
            filteredSearchResults = notEmpty(lseApptsMeta) ? this.showLseAppointments(KIND.LSE.ROLES.COMMITTEES) : { items: [] }
            break
        }
        break

      case TAB[BASE.LSE.PEOPLE].INDEX:
        titleText = `${JARGON.LSE} ${JARGON.PEOPLE}`

        switch (this.props.radio[BASE.LSE.PEOPLE]) {
          case RADIO[BASE.LSE.PEOPLE].BOARD:
            filteredSearchResults = notEmpty(lsePeopleMeta) ? this.showLsePeople(KIND.LSE.PEOPLE.BOARD) : { items: [] }
            break

          case RADIO[BASE.LSE.PEOPLE].COMMITTEES:
          default:
            filteredSearchResults = notEmpty(lsePeopleMeta) ? this.showLsePeople(KIND.LSE.PEOPLE.COMMITTEES) : { items: [] }
            break
        }
        break

      case TAB[BASE.LSE.NEWS].INDEX:
        titleText = `${JARGON.LSE} ${"News"}`
        filteredSearchResults = notEmpty(newsMeta) ? this.showLseNews(KIND.LSE.NEWS) : { items: [] }
        break

      case TAB[BASE.LSE.ADVISERS].INDEX:
        titleText = "LSE Advisers"
        filteredSearchResults = notEmpty(advisersMeta) ? this.showAdvisers(KIND.LSE.ADVISERS) : { items: [] }
        break

      case TAB[BASE.FAVOURITES].INDEX:

        switch (this.props.radio[BASE.FAVOURITES]) {
          case RADIO[BASE.FAVOURITES].PEOPLE:
            titleText = `${firstCharacterToUpperCase(JARGON.FAVOURITE)} ${firstCharacterToUpperCase(JARGON.PEOPLE)}`
            filteredSearchResults = this.props.favourites ? this.showFavouritePeople(KIND.FAVOURITE.PEOPLE) : { items: [] }
            break

          case RADIO[BASE.FAVOURITES].COMPANIES:
          default:
            titleText = `${firstCharacterToUpperCase(JARGON.FAVOURITE)} ${firstCharacterToUpperCase(JARGON.COMPANIES)}`
            filteredSearchResults = this.props.favourites ? this.showFavouriteCompanies(KIND.FAVOURITE.COMPANIES) : { items: [] }
            break
        }

      default:
        // console.error("no valid tab index: ", index)
        break
    }

    // Add title so it can be used for csv export
    filteredSearchResults.titleText = titleText

    const handleChangeRowsPerPage = event => {
      const tableInfoArray = JSON.parse(JSON.stringify(this.props.tableInfoArray))
      tableInfoArray[tabIndex].rowsPerPage = event.target.value
      this.props.common.saveTableInfo({ tableInfoArray })
    }

    // console.log('filteredSearchResults.kind:', filteredSearchResults.kind, ' ', findKind(filteredSearchResults.kind));
    const handleChangePage = (event, newPage) => {
      // console.log('newPage:', newPage)
      const tableInfoArray = JSON.parse(JSON.stringify(this.props.tableInfoArray))
      tableInfoArray[tabIndex].page = newPage
      tableInfoArray[tabIndex] = validateTableInfoPage({ ...tableInfoArray[tabIndex], count: filteredSearchResults.items.length })
      this.props.common.saveTableInfo({ tableInfoArray })
    }

    const handleChangeRadio = eventTargetValue => {
      // console.log('handleChangeRadio value:', eventTargetValue)
      this.props.common.selectRadio({ ...this.props, eventTargetValue })
    }

    const titleBar = () => (
      // @ts-ignore
      <TitleBar
        advisers={this.props.lseCompaniesMeta?.items?.filter(item => item.advisers)?.length} // Count of companies with advisers - used to decide whether to show adviser filter option
        common={this.props.common}
        count={tabIndex === TAB[BASE.DASHBOARD].INDEX ? 0 : filteredSearchResults.items.length}
        features={features}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleChangeRadio={eventTargetValue => handleChangeRadio(eventTargetValue)}
        kind={kind}
        portrait={portrait}
        radio={radio}
        searchIcon={searchIcon}
        tabIndex={tabIndex}
        tableInfo={tableInfo}
        the350club={this.props.the350club}
        titleText={titleText}
      />)

    const count = filteredSearchResults?.items?.length

    const nexusMenu = ({ csvButton = null, news = null, prompt = null, showFilters = true }) => (
      // @ts-ignore
      <NexusMenu portrait={portrait}  >
        {news && this.nsmSearchForm({ count, label: "keyword search", tabIndex })}
        {prompt && this.lseSearchForm(tabIndex, prompt)}
        {news && newsTimePeriodForm({ radio, handleChangeRadio })}
        {csvButton && this.csvButton({ kind, tabIndex })}
        {csvButton && showFilters && <Divider style={{ marginRight: LAYOUT.COLUMN_PADDING }} />}
        {showFilters && getCheckboxMenu({ ...menuProps })}
      </NexusMenu>
    )

    const searchMenu = components =>
      <
        // @ts-ignore
        SearchMenu portrait={portrait}>
        {this.searchForm(filteredSearchResults, components)}
      </SearchMenu>

    const companyPrompt = `${JARGON.COMPANY} name or ${JARGON.EPIC}`
    const adviserPrompt = `${JARGON.ADVISER} name`
    const personPrompt = `${JARGON.PERSON} name`
    const csvButton = true
    // Export as CSV on the LSE Advisers page is Developer-only for now
    const advisersCsvButton = features.Developer

    // Handle link to either annual report (strart with "https:") or nexus company
    const handleOnClick = pathname => {
      if (pathname?.startsWith("https:"))
        window.open(pathname, "_blank")
      else
        this.props.common.selectRow({ ...this.props, pathname })
    }

    const dashboardData = lseCompaniesMeta?.items && lseApptsMeta?.items

    return (
      <React.Fragment>
        {/* navbar */}
        < Navbar
          icon={< logo />}
          title={title}
          state={this.state}
          portrait={portrait}
        />

        {/* tabs bar */}
        < HomePageTabs />

        {/* title bar*/}
        {titleBar()}

        <MainSection portrait={portrait} style={{ backgroundColor: COLOR.BACKGROUND }}>

          <DataCard portrait={portrait} showCard={false}>

            {/* menu area */}
            {tabIndex === TAB[BASE.SEARCH].INDEX && searchMenu(3)}

            {/* #region landscape render menu area */}
            {!portrait && tabIndex === TAB[BASE.DASHBOARD].INDEX && lseCompaniesMeta && nexusMenu({ meta: lseCompaniesMeta })}
            {!portrait && tabIndex === TAB[BASE.LSE.COMPANIES].INDEX && lseCompaniesMeta && nexusMenu({ csvButton, meta: lseCompaniesMeta, prompt: companyPrompt })}
            {!portrait && tabIndex === TAB[BASE.LSE.ROLES].INDEX && lseApptsMeta && nexusMenu({ csvButton, meta: lseApptsMeta, prompt: personPrompt })}
            {!portrait && tabIndex === TAB[BASE.LSE.PEOPLE].INDEX && lsePeopleMeta && nexusMenu({ csvButton, meta: lsePeopleMeta, prompt: personPrompt })}
            {!portrait && tabIndex === TAB[BASE.LSE.ADVISERS].INDEX && advisersMeta && nexusMenu({ csvButton: advisersCsvButton, meta: advisersMeta, prompt: adviserPrompt })}
            {!portrait && tabIndex === TAB[BASE.LSE.NEWS].INDEX && newsMeta && nexusMenu({ meta: newsMeta, news: true, prompt: companyPrompt })}
            {/* #endregion landscape render menu area */}

            {/* #region portrait render menu area - search box only (filters render once, below the table) */}
            {portrait && tabIndex === TAB[BASE.LSE.COMPANIES].INDEX && lseCompaniesMeta && nexusMenu({ prompt: companyPrompt, showFilters: false })}
            {portrait && tabIndex === TAB[BASE.LSE.ROLES].INDEX && lseApptsMeta && nexusMenu({ prompt: personPrompt, showFilters: false })}
            {portrait && tabIndex === TAB[BASE.LSE.PEOPLE].INDEX && lsePeopleMeta && nexusMenu({ prompt: personPrompt, showFilters: false })}
            {portrait && tabIndex === TAB[BASE.LSE.ADVISERS].INDEX && advisersMeta && nexusMenu({ prompt: adviserPrompt, showFilters: false })}
            {portrait && tabIndex === TAB[BASE.LSE.NEWS].INDEX && newsMeta && nexusMenu({ prompt: companyPrompt, showFilters: false })}
            {/* #endregion portrait render menu area */}

            {/* data area */}
            {CONSTANTS.ENABLE_INTRO_IMAGE && tabIndex === TAB[BASE.SEARCH].INDEX && searchResults && searchResults.items.length === 0 &&
              <ScrollableContentCard>
                <div style={{ padding: "20px" }} >
                  <Typography>
                    then click to view their connections:
                  </Typography>
                  <img src={introImage} style={{ display: "block", width: "100%", maxWidth: "512px", marginTop: "20px", marginLeft: "auto", marginRight: "auto" }} alt="intro" />
                </div>
              </ScrollableContentCard>
            }

            {tabIndex === TAB[BASE.SEARCH].INDEX && this.SearchResultsComponent(filteredSearchResults)}
            {tabIndex === TAB[BASE.DASHBOARD].INDEX && (dashboardData && <Dashboard {...this.props} handleOnClick={row => handleOnClick(row)} /> || <GettingData />)}
            {tabIndex === TAB[BASE.LSE.COMPANIES].INDEX && ((notEmpty(lseCompaniesMeta) && this.SearchResultsComponent(filteredSearchResults)) || <GettingData />)}
            {tabIndex === TAB[BASE.LSE.ROLES].INDEX && ((notEmpty(lseApptsMeta) && this.SearchResultsComponent(filteredSearchResults)) || <GettingData />)}
            {tabIndex === TAB[BASE.LSE.PEOPLE].INDEX && ((notEmpty(lsePeopleMeta) && this.SearchResultsComponent(filteredSearchResults)) || <GettingData />)}
            {tabIndex === TAB[BASE.LSE.NEWS].INDEX && ((notEmpty(newsMeta) && this.SearchResultsComponent(filteredSearchResults)) || <GettingData />)}
            {tabIndex === TAB[BASE.LSE.ADVISERS].INDEX && (notEmpty(advisersMeta) && this.SearchResultsComponent(filteredSearchResults) || <GettingData />)}
            {tabIndex === TAB[BASE.FAVOURITES].INDEX && ((this.props.favourites && this.SearchResultsComponent(filteredSearchResults)) || <GettingData />)}

            {/* #region portrait render menu area */}
            {/* menu area */}
            {portrait && tabIndex === TAB[BASE.DASHBOARD].INDEX && lseCompaniesMeta && nexusMenu({ meta: lseCompaniesMeta })}
            {portrait && tabIndex === TAB[BASE.LSE.COMPANIES].INDEX && lseCompaniesMeta && nexusMenu({ csvButton, meta: lseCompaniesMeta })}
            {portrait && tabIndex === TAB[BASE.LSE.ROLES].INDEX && lseApptsMeta && nexusMenu({ csvButton, meta: lseApptsMeta })}
            {portrait && tabIndex === TAB[BASE.LSE.PEOPLE].INDEX && lsePeopleMeta && nexusMenu({ csvButton, meta: lsePeopleMeta })}
            {portrait && tabIndex === TAB[BASE.LSE.ADVISERS].INDEX && advisersMeta && nexusMenu({ csvButton: advisersCsvButton, meta: advisersMeta })}
            {portrait && tabIndex === TAB[BASE.LSE.NEWS].INDEX && newsMeta && nexusMenu({ meta: lsePeopleMeta })}
            {/* #endregion portrait render menu area */}

            <DeleteFavouriteModal
              open={this.state.showDeleteFavouriteModal}
              onClose={() => { this.setState({ showDeleteFavouriteModal: false }) }}
              title={this.state.favouriteToDelete.title}
              loading={this.state.deleting}
              onSubmit={() => this.handleOnSubmitDeleteFav()}
            />

            <ExportCsvModal
              rowCount={filteredSearchResults.items.length}
              open={this.state.showCsvModal}
              onClose={() => this.setState({ showCsvModal: false })}
              // Set portrait as false so we always create csv using landscape columns
              onSubmit={props => { this.handleExportCsvModalSubmit({ ...filteredSearchResults, ...props, portrait: false }) }}
              title={"Export to CSV file"}
            />

            < MaxFavouritesReachedModal
              open={this.state.showMaxFavouritesReached}
              onClose={() => { this.setState({ showMaxFavouritesReached: false }) }}
              category={this.state.category}
              max={KEY_VALUES.MAX_FAVOURITES}
            />

            <UnderDevelopmentModal
              show={this.state.showUnderDevelopmentModal}
              onHide={() => {
                this.setState({ showUnderDevelopmentModal: false })
              }}
            />

            <WhyRegisterModal
              open={this.state.showWhyRegisterModal}
              onClose={() => { this.setState({ showWhyRegisterModal: false }) }}
            />

            {this.props.showErrorModal && this.errorModal()}

            {this.state.showStandardTrialModal && !this.props.standardTrialModalShown &&
              standardTrialDaysLeft !== undefined &&
              <StandardTrialModal />
            }

            {this.state.showUrlTrialModal && !this.props.urlTrialModalShown &&
              <UrlTrialModal />
            }

            {/* If we are logged in but 'idle' show the the IdleLogoutModal */}
            {this.props.isLoggedIn && this.props.activityStatus === ACTIVITY_STATUS.IDLE && <IdleLogoutModal />}

            {/* If we have been logged out as a result of 'idle' show the the IdleLogoutModal */}
            {this.props.idleLoggedOut && <IdleLogoutModal />}

            {this.props.the350club && (isChrome() || isMSEdge()) && !isIos() &&
              <The350ClubIntroModal
                open={this.state.showThe350ClubIntroModal}
                onClose={() => {
                  // set cookie so don't show modal again
                  document.cookie = `${COOKIES.NO_350_CLUB_MODAL_COOKIE} = true; expires = Tue, 31 Dec 2030 23: 00: 00 UTC; SameSite = None; Secure`
                  this.setState({ showThe350ClubIntroModal: false })
                }}
              />
            }

          </DataCard>

        </MainSection>

        <Footer urlSource={this.props.urlSource} />

      </React.Fragment >
    )
  }
}

const mapStateToProps = ({ advisers, app, common, constants, enums, fav, lse, news, nexus, search, user }) => {
  return {
    // app
    advisersMeta: advisers.advisers,
    advisersSynced: advisers.synced,
    features: app.features,
    rollups: app.rollups,
    activityStatus: app.activityStatus,
    isLoggedIn: !!app.token,
    idleLoggedOut: app.idleLoggedOut,

    // commom.
    checkboxes: common.checkboxes,
    companyId: common.companyId,
    currentUrl: common.currentUrl,
    nexusView: common.nexusView,
    newsId: common.newsId,
    personId: common.personId,
    previousCheckboxes: common.previousCheckboxes,
    prevTabIndex: common.prevTabIndex,
    radio: common.radio,
    searchStringObj: common.searchStringObj,
    standardTrialModalShown: common.standardTrialModalShown,
    tabIndex: common.tabIndex,
    tableInfo: common.tableInfoArray[common.tabIndex ?? 0],
    tableInfoArray: common.tableInfoArray,
    tableOrder: common.tableOrder,
    the350club: common.the350club,
    urlSource: common.urlSource,
    urlTrialCode: common.urlTrialCode,
    urlTrialDaysLeft: common.urlTrialDaysLeft,
    urlTrialModalShown: common.urlTrialModalShown,
    userCheckboxes: common.userCheckboxes,

    // enums: { ...enums.enums }, // BAD!!

    // fav
    favourites: fav.favourites,
    favouritesFetching: fav.isFetching,

    // lse
    lseCompaniesMeta: lse.companiesMeta,
    lseApptsMeta: lse.apptsMeta,
    lsePeopleMeta: lse.peopleMeta,
    lseEventsMeta: lse.eventsMeta,

    // string
    previousSearchString: search.previousSearchString,
    scope: search.scope,
    searchResults: search.searchResults,
    seed: search.seed,
    submitting: search.submitting,
    newSearch: search.newSearch,
    searchSynced: search.synced, // searchResults are synced with favourites

    // nexus
    entities: nexus.entities,

    // news
    newsMeta: news.meta,
    newsIds: news.searchResults,
    nsmSearchString: news.searchString,
    newsErrorMessage: news.errorMessage,

    // search
    showErrorModal: search.showErrorModal,
    statusCode: search.statusCode,
    reasonPhrase: search.reasonPhrase,
    customReason: search.customReason,

    // user selectors
    standardTrialDaysLeft: userSelectors.getTrialDaysRemaining(user),

    portrait: user.portrait,
    orderSet: user.portrait ? 1 : 0, // The tableOrder setting.
    constants: constants,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    advisers: bindActionCreators(advisersActions, dispatch),
    app: bindActionCreators(appActions, dispatch),
    common: bindActionCreators(commonActions, dispatch),
    fav: bindActionCreators(favActions, dispatch),
    lse: bindActionCreators(lseActions, dispatch),
    news: bindActionCreators(newsActions, dispatch),
    nexus: bindActionCreators(nexusActions, dispatch),
    search: bindActionCreators(searchActions, dispatch),
    synopsis: bindActionCreators(synopsishActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage)

